import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import './style.css';

class AddOption extends Component {
  constructor(props){
    super(props)

    this.state={
      editOptionsUpdate : true,
      pageTitle : 'Add Option',
      pageButton : 'Add Option',
      editOptions : false,
      order_no : "",
      option : "",
      quesId : "",
      optionID : '',
      option_id : '',
      validationMsg : {},
    }

    this.onChange = this.onChange.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentDidMount(){
    if(this.props.quesId){
      this.setState({quesId : this.props.quesId});
    }
    // if(this.props.editOptions && this.props.editOptionsData){
    //   alert("edit");
    //   console.log(this.props.editOptionsData);
    //   this.setState({
    //     editOptions : true, 
    //     option :  this.props.editOptionsData.options,
    //     optionID : this.props.editOptionsData.option_id,
    //     quesId : this.props.editOptionsData.ques_id,
    //     order_no : this.props.editOptionsData.order_no
    //   });
    // }
  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsOptionAddSuccess && nextProps.demoGraphicsOptionSuccessmessage){
      alert(nextProps.demoGraphicsOptionSuccessmessage);
      this.props.emptyDemographicsOption();
      window.history.back();
    }else if(nextProps.demoGraphicsOptionFailmessage){
      alert(nextProps.demoGraphicsOptionFailmessage);
      this.props.emptyDemographicsOption();
    }

    if(nextProps.demoGraphicsOptionUpdateSuccess && nextProps.demoGraphicsOptionUpdateSuccessMessage){
      alert(nextProps.demoGraphicsOptionUpdateSuccessMessage);
      this.props.emptyDemographicsOption();
      window.history.back();
    }else if(nextProps.demoGraphicsOptionUpdateFailMessage){
      alert(nextProps.demoGraphicsOptionUpdateFailMessage);
      this.props.emptyDemographicsOption();
    }else
    
    if(nextProps.editOptions && nextProps.editOptionsData && this.state.editOptionsUpdate){
      this.setState({
        pageTitle : 'Update Option',
        pageButton : 'Edit',
        editOptions : true, 
        option_id : nextProps.editOptionsData._id,
        option :  nextProps.editOptionsData.options,
        optionID : nextProps.editOptionsData.option_id,
        quesId : nextProps.editOptionsData.ques_id,
        order_no : nextProps.editOptionsData.order_no+"",
      });
    }
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
		let valid = true;
    let error = {};

		if (this.state.option === "") {
      error.option = "Can't leave empty";
			valid = false;
    }
    if (this.state.order_no === "") {
      error.order_no = "Can't leave empty";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){

    if(this.state.editOptions){
      this.setState({ editOptions : false, pageButton : 'Update'});
    }else if(this.props.editOptions){
      let quesData = {};
      if (this.handleValidation()) {
        quesData.option_id = this.state.option_id;
        quesData.optionID = this.state.optionID;
        quesData.ques_id = this.state.quesId;
        quesData.optionText = this.state.option;
        quesData.order_no = this.state.order_no;     
        this.props.updateOptionByQuestion(quesData);
        this.setState({ editOptionsUpdate : false});
      }
    }else{
     
      let quesData = {};
      if (this.handleValidation()) {
        quesData.ques_id = this.state.quesId;
        quesData.optionText = this.state.option;
        quesData.order_no = this.state.order_no;     
        this.props.addOptionByQuestion(quesData);  
      }
    }
  }

  backToPage(){
    window.history.back();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1> {this.state.pageTitle}</h1></div>
            <div className = "setbackbutton">
            <br/><button className = "editstudybackbtn"   onClick={this.backToPage.bind(this)}>Back</button><br/>
            <div className = "studypage">
            <label id = "lbl1">Option value</label>
            <input type="text" className = "textFields" placeholder = "Option value" name="option" value={this.state.option} onChange={this.onChange} disabled = {this.state.editOptions} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.option}</div><br/>

            {/* <label id = "lbl1">Category ID</label>
            <input type="text" className = "textFields" placeholder = "Category ID" name="catID" value={this.state.catID} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.catID}</div><br/> */}

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Option Order" name="order_no" value={this.state.order_no} onChange={this.onChange} disabled = {this.state.editOptions} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            <div>
            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  > {this.state.pageButton} </button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddOption;


// WEBPACK FOOTER //
// ./src/components/demographics/addOption.js